<div class="btrans-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a routerLink="/utilisateur/codes" class="crumb-link"><i class="bi bi-arrow-left"></i> Retour au tableau de bord codes</a>
      <span class="crumb-current">Transactions professionnelles</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Compte pro</p>
        <h1>{{bDescription}}</h1>
        <p class="lead">Accédez rapidement aux opérations professionnelles de ce compte.</p>
      </div>
      <div class="pill-row d-md-none">
        <span class="pill pill-strong">Compte : {{accountNumber}}</span>
        <span class="pill">Achats / Dépôts / Retraits / Transferts</span>
        <span class="pill">Rapports & Facturation</span>
      </div>
    </div>
  </div>

  <div class="row g-3">
    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/affaire/achats/{{accountNumber}}">
        <div class="icon-circle"><i class="bi bi-cart-check"></i></div>
        <div>
          <h5>Achats</h5>
          <p>Suivre et vérifier les achats effectués.</p>
        </div>
      </a>
    </div>

    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/affaire/depots/{{accountNumber}}">
        <div class="icon-circle"><i class="bi bi-arrow-down-circle"></i></div>
        <div>
          <h5>Dépôts</h5>
          <p>Détails des dépôts crédités sur ce compte.</p>
        </div>
      </a>
    </div>

    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/affaire/retraits/{{accountNumber}}">
        <div class="icon-circle"><i class="bi bi-arrow-up-circle"></i></div>
        <div>
          <h5>Retraits</h5>
          <p>Historique des retraits et validations.</p>
        </div>
      </a>
    </div>

    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/affaire/transfert/{{accountNumber}}">
        <div class="icon-circle"><i class="bi bi-arrow-left-right"></i></div>
        <div>
          <h5>Transferts</h5>
          <p>Transferts entrants et sortants liés au compte.</p>
        </div>
      </a>
    </div>

    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/affaire/mensualites/{{accountNumber}}">
        <div class="icon-circle"><i class="bi bi-calendar3"></i></div>
        <div>
          <h5>Rapport mensuel</h5>
          <p>Vue consolidée par mois (dépôts, retraits, transferts).</p>
        </div>
      </a>
    </div>

    <div class="col-sm-6 col-lg-4">
      <a class="action-card card-glass" routerLink="/utilisateurs/affaire/facturations/{{accountNumber}}">
        <div class="icon-circle"><i class="bi bi-receipt"></i></div>
        <div>
          <h5>Facturation</h5>
          <p>Factures, commissions et justificatifs.</p>
        </div>
      </a>
    </div>
  </div>
</div>
